<script>
    import { onMount } from "svelte";
    import MOCK_DATA from '../../Data/data.js';
    import { store } from '../../store';
    
    // const { DATAS = [] } = MOCK_DATA.roadmapData;

    const DATAS = MOCK_DATA.ROADMAP_DATA[`DATAS_${$store.locale}`];

    onMount(() => {
        if (!window.jQuery) window.jQuery = jQuery;
        jQuery(".slider")
        .on('afterChange init', function(event, slick, direction){
                if($store.type === 'pc') {
                    slick.$slides.removeClass('prevSlide').removeClass('nextSlide');

                    // find current slide
                    for (var i = 0; i < slick.$slides.length; i++)
                    {
                        var $slide = jQuery(slick.$slides[i]);
                        if ($slide.hasClass('slick-current')) {
                            // update DOM siblings
                            $slide.prev().addClass('prevSlide');
                            $slide.next().addClass('nextSlide');
                            break;
                        }
                    }
                }

            }
        )
        .on('beforeChange', function(event, slick) {
            if($store.type === 'pc') slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
        })
        .slick({
            slidesToShow: 1,
            centerMode: true,
            centerPadding: $store.type === 'pc' ? `${30 * $store.r}%`: "0%",
            speed: 500,
            dots: false,
            prevArrow: false,
            nextArrow: false,
        });
    });

    

    function handlePrev() {
        jQuery(".slider").slick('prev');
    }

    function handleNext() {
        jQuery(".slider").slick('next');
    }
</script>

<!------------------------------------------->
<!----------------MARKUP----------------------->
<!------------------------------------------->

{#if $store.type === 'pc'}

<div class="position-relative">
    <span on:click={handlePrev} class="slick-prev" style={`top: 150px; left: ${($store.r * 200)}px;`}>
        <img src="/images/prev_button.png" alt="prev" style={`width: ${($store.r * 150)}px;height: ${($store.r * 150)}px;`}>
    </span>
    <span on:click={handleNext} class="slick-next" style={`top: 150px; right: ${($store.r * 200)}px;`}>
        <img src="/images/next_button.png" alt="next" style={`width: ${($store.r * 150)}px;height: ${($store.r * 150)}px;`}>
    </span>
    <div class="slider" style={`width: ${$store.r * 1200}px`}>
        {#each DATAS as data}
            <div class="slide">
                <div class="child-element card font-roboto">
                    <div class="card-body">
                        <div class="description" style={`padding: 0 ${($store.r * 20)}px;`}>
                            <h5 class="card-title text-dark">{data.title}</h5>
                            <p class="card-text text-dark">
                                {#each data.list as item}
                                    <div>- {item}</div>
                                {/each}
                            </p>        
                        </div>
                    </div>
                </div>                    
            </div>
        {/each}
    </div>
</div>
{:else}
<div class="position-relative">
    <span on:click={handlePrev} class="slick-prev" 
        style={
            `top: ${$store.type === 'pc' ? 150: 75}px; 
            left: ${$store.type === 'pc' ? ($store.r * 20):($store.r * -20) }px;`
        }
    >
        <img src="/images/prev_button.png" alt="prev" style={`width: ${($store.r * 80)}px;height: ${($store.r * 80)}px;`}>
    </span>
    <span on:click={handleNext} class="slick-next" 
        style={
            `top: ${$store.type === 'pc' ? 150: 75}px; 
            right: ${$store.type === 'pc' ? ($store.r * 20):($store.r * -20) }px;`
        }    
    >
        <img src="/images/next_button.png" alt="next" style={`width: ${($store.r * 80)}px;height: ${($store.r * 80)}px;`}>
    </span>
    <div class="slider" style={`width: ${$store.r * 500}px`}>
        {#each DATAS as data}
            <div class="slide">
                <div class="child-element card font-roboto">
                    <div class="card-body">
                        <div class="description" style={`padding: 0 ${($store.r * 70)}px;`}>
                            <h5 class="card-title text-dark">{data.title}</h5>
                            <p class="card-text text-dark">
                                {#each data.list as item}
                                    <div>- {item}</div>
                                {/each}
                            </p>        
                        </div>
                    </div>
                </div>                    
            </div>
        {/each}
    </div>
</div>
{/if}
<!------------------------------------------->
<!----------------STYLE----------------------->

<!------------------------------------------->
<style>

    .description {
        font-size: 0.8vw !important;
    }

    .card-text {
        text-align: left;
    }
    .slider {
        width: 1200px;
        margin: 20px auto;
        text-align: center;
        /* padding: 20px; */
        color: white;
    }
    .slider .slide {
        padding: 0;
    }
    .slider .slide .child-element {
        transition: all 0.5s ease;
        background: transparent;
        border: none;
        width: 100%;
        margin: 60px 0;
        transition: font-size  1s;
    }

    .description h5 {
        font-size: 25px;
        font-weight: bold;
    }

    .card-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 35px 20px -40px #333;
        background-image: linear-gradient(to right, #efefef , #fff, white);        
        padding: 0 70px;
        /* height: 300px; */
        overflow: hidden;
        height: 25vw;
    }
    .slider .slide.slick-center .child-element {
        background: transparent;
        margin: 0;
        z-index: 5;
        /* height: calc(var(--theme-height) * 1px);   */
        /* height: 500px;   */
        width: calc(var(--theme-width) * 1px);      
        margin-left: calc(-90px * var(--theme-r));
        margin-left: -15%;
        width: 130%;
        
        max-width: initial;
        border: none;
    }

    .slick-next, .slick-prev {
        position: absolute;
        z-index: 6;
    }

    .slider .slide.slick-center .description {
        font-size: 1.1vw;
    }

    .slider .slide.slick-center .card-body {
        /* height: 800px; */
    }

    :global(.nextSlide) {
        transform: translateX(calc(-100px * var(--theme-r)));
        
        color: transparent;
        text-shadow: 0 0 5px rgba(0,0,0,0.5);
    }

    :global(.prevSlide) {
        transform: translateX(calc(100px * var(--theme-r)));
    }    

    :global(.nextSlide .child-element .text-dark) {        
        color: transparent !important;
        text-shadow: 0 0 5px rgba(0,0,0,0.5);
    }

    :global(.prevSlide .child-element .text-dark) {
        color: transparent !important;
        text-shadow: 0 0 5px rgba(0,0,0,0.5);
    } 

    #roadmap :global(.slick-prev) {
        top: 9vw;
        left: 20vw;
    }

    #roadmap :global(.slick-next) {  
        top: calc(150px * var(--theme-w));
        right: calc(230px * 1 / var(--theme-w));
    }

    .slider :global(.slick-arrow) {
        position: absolute;
        z-index: 6;
        cursor: pointer;
    }

    .slider :global(.slick-arrow img) {
        width: calc(150px * var(--theme-r));
        height: calc(150px * var(--theme-r));
    }

    :global(.bi-caret-right-fill::before) {
        border: 5px solid transparent;
        border-radius: 50%;
        background-image: linear-gradient(#444444, #444444), linear-gradient(to right, #b7b7b7, #b7b7b7, #fff);
        background-origin: border-box;
        background-clip: content-box, border-box;
    }
    
    @media screen and (max-width: 640px) {
        .card-body {
            padding: 0
        }

        .slider .slide.slick-center .card-body {
            /* height: 200px !important; */
        }

        .slider .slide.slick-center .child-element {
            background: transparent;
            margin: 0;
            z-index: 5;
            /* height: calc(var(--theme-height) * 1px);   */
            /* height: 200px !important; */
            max-width: initial;
            border: none;
        }
        
        .description {
            font-size: 0.8vw;
        }

        .card-text {
            text-align: left;
        }
        .slider {
            width: 100%;
            text-align: center;
            color: white;
        }
        .slider .slide {
            width: 300px;
        }
        .slider .slide .child-element {
            transition: all 0.5s ease;
            background: transparent;
            border: none;
            width: '100%';
            margin: auto;
            transition: font-size  1s;
        }

        .description h5 {
            font-size: 4.2vw;
            font-weight: bold;
            margin: 0;
        }

        .card-body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 35px 20px -40px #333;
            background-image: linear-gradient(to right, #efefef , #fff, white);        height: 300px;
            height: calc(var(--theme-height) * 1px);
            /* padding: 0 calc(var(--theme-padding) * 1px) */
        }

        .card-text {
            font-size: 2.5vw;
        }

        .slick-next, .slick-prev {
            position: absolute;
            top: 45% !important;
            z-index: 6;
        }

        .slider .slide.slick-center .description {
            font-size: 1.2vw;
        }

        .slider :global(.slick-arrow) {
            position: absolute;
            z-index: 6;
            cursor: pointer;
        }

        .slider :global(.slick-arrow img) {
            width: calc(150px * var(--theme-r));
            height: calc(150px * var(--theme-r));
        }

        .slider .slide.slick-center .child-element {
            background: transparent;
            margin: 0;
            z-index: 5;
            height: 77vw;
            /* height: 500px;   */
            width: 100%;
            max-width: initial;
            border: none;
        }

        :global(.bi-caret-right-fill::before) {
            border: 5px solid transparent;
            border-radius: 50%;
            background-image: linear-gradient(#444444, #444444), linear-gradient(to right, #b7b7b7, #b7b7b7, #fff);
            background-origin: border-box;
            background-clip: content-box, border-box;
        }
    }
</style>
